import "core-js/modules/es.array.push.js";
import { defineComponent, ref } from 'vue';
import Header from './components/common/Header.vue';
import MobileHeader from './components/common/MobileHeader.vue';
import PageFooter from './components/common/PageFooter.vue';
import MobilePageFooter from './components/common/MobilePageFooter.vue';
import { onMounted } from 'vue';
import APIHelper from './api/APIHelper';
import { baseUrl, navData as nav } from './Global';
export default defineComponent({
  name: 'App',
  components: {
    Header,
    MobileHeader,
    PageFooter,
    MobilePageFooter
  },
  setup() {
    new APIHelper();
    //console.log(APIHelper.getInstance()===APIHelper.getInstance())
    const navData = ref([]);
    //console.log(process.env)
    onMounted(() => {
      APIHelper.getInstance().getJson(baseUrl + 'json/navigation.json').then(res => {
        //console.log(res)
        navData.value = res;
        res.forEach(item => {
          nav.push(item);
        });
      });
    });
    return {
      navData
    };
  }
});